import ViewStore from './ViewStore'

export default ViewStore
